import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import { ReactComponent as SectionIcon } from "../../../images/sectionimage/Section.svg";
import useStyles from "../../../../styles";
import ViewScoreScheme from "./ViewScoreScheme";


function ScoreScheme() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon:<SectionIcon />,
      mainheading: "Score Scheme",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext:"Create New scheme",
      addbtnicon: <AddIcon />,
      addbtnstyle: "bluebtn",
      path:"/admin/addscorescheme",
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading}/>
      <ViewScoreScheme/>
    </div>
  );
}
export default ScoreScheme;